import axios from 'axios'
import { ElMessage } from 'element-plus'
import router from '@/router';
import { eventBus } from '@/utils/eventBus'

// 创建axios实例
// const service = axios.create({
//     baseURL: 'http://localhost:8082/api', // 确保与后端端口一致
//     timeout: 10000 // 请求超时时间
// })

// 修改为后端服务器域名下的端口 时间0806
const service = axios.create({
    baseURL: '/api', // 确保与后端端口一致
    timeout: 10000,  // 请求超时时间
})

// 获取token的函数
const getToken = () => {
    return localStorage.getItem('auth_token')
}

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 在请求头中添加token
        const token = getToken()
        console.log("请求头中获取到的token", token)
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
        }

        // 为文件上传请求设置更长的超时时间
        if (config.url?.includes('/file/upload') ||
            config.url?.includes('/upload') ||
            (config.data instanceof FormData)) {
            config.timeout = 600000; // 5分钟超时
        }

        return config
    },
    error => {
        return Promise.reject(error)
    }
)


// 响应拦截器
service.interceptors.response.use(
    response => {
        // 统一处理响应
        const res = response.data

        // 如果业务码为200，直接返回数据
        if (res.code === '200') {
            // 检查是否是登录相关的请求
            const isLoginRequest = response.config.url?.includes('/auth/login') ||
                response.config.url?.includes('/auth/wechat/login/status')

            // if (isLoginRequest && res.data?.token) {
            //     // 登录成功，获取重定向路径
            //     const redirect = getRedirectPath()
            //     if (redirect) {
            //         // 使用setTimeout确保在响应处理完成后跳转
            //         setTimeout(() => {
            //             router.push(redirect)
            //             // 清除存储的重定向路径
            //             clearRedirectPath()
            //         }, 0)
            //     } else {
            //         // 没有重定向路径，跳转到首页
            //         setTimeout(() => {
            //             router.push('/home')
            //         }, 0)
            //     }
            // }
            const isAdminLogin = response.config.url?.includes('/auth/login/admin')

            if (isLoginRequest && res.data?.token) {
                // 如果是管理员登录，我们不在这里处理跳转，由登录页面自己处理
                if (isAdminLogin) {
                    // 管理员登录的跳转已经在AdminLoginPage.vue中处理，这里不做任何事
                } else {
                    // 普通用户登录，执行原来的跳转逻辑
                    const redirect = getRedirectPath()
                    if (redirect) {
                        // 使用setTimeout确保在响应处理完成后跳转
                        setTimeout(() => {
                            router.push(redirect)
                            // 清除存储的重定向路径
                            clearRedirectPath()
                        }, 0)
                    } else {
                        // 没有重定向路径，跳转到首页
                        setTimeout(() => {
                            router.push('/home')
                        }, 0)
                    }
                }
            }

            return res
        } else {
            // 业务错误处理
            return Promise.reject(res)
        }
    },
    error => {

        // if (error.response && error.response.status === 401) {
        //     // 清除无效的token
        //     // localStorage.removeItem('auth_token');
        //
        //     const requestUrl = error.config?.url;
        //     const isUserInfoRequest = requestUrl?.includes('/user/current');
        //
        //     if (isUserInfoRequest && error.config._retryCount < 3) {
        //         error.config._retryCount = (error.config._retryCount || 0) + 1;
        //
        //         // 延迟重试
        //         return new Promise(resolve => {
        //             setTimeout(() => {
        //                 resolve(service(error.config));
        //             }, 500 * error.config._retryCount);
        //         });
        //     }
        //
        //     // 重置全局用户状态
        //     eventBus.clearUser();
        //
        //     // 获取当前路径并保存为重定向路径
        //     const currentPath = window.location.hash.replace('#', '') || '/';
        //
        //     // 只有在非首页且非登录页面时才跳转到登录页面
        //     if (currentPath !== '/' && currentPath !== '/home' && currentPath !== '/login') {
        //         // ElMessage.error('登录已过期，请重新登录');
        //         // 保存重定向路径
        //         saveRedirectPath(currentPath)
        //         // 跳转到登录页
        //         router.push('/login');
        //     }
        // }

        if (error.response && error.response.status === 401) {
            const isAdmin = localStorage.getItem('is_admin') === 'true';
            const requestUrl = error.config?.url;
            const isUserInfoRequest = requestUrl?.includes('/user/current');

            if (isUserInfoRequest && error.config._retryCount < 3) {
                error.config._retryCount = (error.config._retryCount || 0) + 1;

                // 延迟重试
                return new Promise(resolve => {
                    setTimeout(() => {
                        resolve(service(error.config));
                    }, 500 * error.config._retryCount);
                });
            }

            // 重置全局用户状态
            eventBus.clearUser();

            // 获取当前路径并保存为重定向路径
            const currentPath = window.location.hash.replace('#', '') || '/';

            // 只有在非首页且非登录页面时才跳转到登录页面
            if (currentPath !== '/' && currentPath !== '/home' && currentPath !== '/login' && currentPath !== '/admin/login') {
                if (isAdmin) {
                    // 管理员用户，跳转到管理员登录页
                    ElMessage.error('管理员登录已过期，请重新登录');
                    // 清除管理员标志
                    localStorage.removeItem('is_admin');
                    // 保存重定向路径
                    saveRedirectPath(currentPath)
                    // 跳转到管理员登录页
                    router.push('/admin/login');
                } else {
                    // 普通用户，跳转到普通登录页
                    ElMessage.error('登录已过期，请重新登录');
                    // 保存重定向路径
                    saveRedirectPath(currentPath)
                    // 跳转到登录页
                    router.push('/login');
                }
            }
        }

        return Promise.reject(error)
    }
)

// 保存重定向路径到sessionStorage
const saveRedirectPath = (path) => {
    sessionStorage.setItem('redirect_path', path)
}

// 获取重定向路径
const getRedirectPath = () => {
    return sessionStorage.getItem('redirect_path')
}

// 清除重定向路径
const clearRedirectPath = () => {
    sessionStorage.removeItem('redirect_path')
}

// 封装请求方法
// const request = {
//     get(url, config = {}) {
//         return service.get(url, config)
//     },
//     post(url, data) {
//         return service.post(url, data)
//     },
//     put(url, data) {
//         return service.put(url, data)
//     },
//     delete(url, params) {
//         return service.delete(url, { params })
//     }
// }
// 在request.js中添加对params的支持
const request = {
    get(url, config = {}) {
        return service.get(url, config)
    },
    post(url, data, config = {}) {
        return service.post(url, data, config)
    },
    put(url, data, config = {}) {
        return service.put(url, data, config)
    },
    delete(url, config = {}) {
        return service.delete(url, config)
    }
}


export default request